var map = {
	"./countries/abkhazia.svg": [
		69040,
		9040
	],
	"./countries/afghanistan.svg": [
		62111,
		2111
	],
	"./countries/aland-islands.svg": [
		60758,
		758
	],
	"./countries/albania.svg": [
		71269,
		1269
	],
	"./countries/algeria.svg": [
		92680,
		2680
	],
	"./countries/american-samoa.svg": [
		16891,
		6891
	],
	"./countries/andorra.svg": [
		64862,
		4862
	],
	"./countries/angola.svg": [
		28173,
		8173
	],
	"./countries/anguilla.svg": [
		28044,
		8044
	],
	"./countries/antigua-and-barbuda.svg": [
		14610,
		4610
	],
	"./countries/argentina.svg": [
		47470,
		7470
	],
	"./countries/armenia.svg": [
		31372,
		1372
	],
	"./countries/aruba.svg": [
		60840,
		840
	],
	"./countries/australia.svg": [
		95703,
		5703
	],
	"./countries/austria.svg": [
		39164,
		9164
	],
	"./countries/azerbaijan.svg": [
		90080,
		80
	],
	"./countries/azores-islands.svg": [
		11388,
		1388
	],
	"./countries/bahamas.svg": [
		8602,
		8602
	],
	"./countries/bahrain.svg": [
		91298,
		1298
	],
	"./countries/balearic-islands.svg": [
		97201,
		7201
	],
	"./countries/bangladesh.svg": [
		67488,
		7488
	],
	"./countries/barbados.svg": [
		43553,
		3553
	],
	"./countries/basque-country.svg": [
		83695,
		3695
	],
	"./countries/belarus.svg": [
		25969,
		5969
	],
	"./countries/belgium.svg": [
		33222,
		841
	],
	"./countries/belize.svg": [
		61550,
		1550
	],
	"./countries/benin.svg": [
		35651,
		5651
	],
	"./countries/bermuda.svg": [
		44325,
		4325
	],
	"./countries/bhutan-1.svg": [
		75617,
		5617
	],
	"./countries/bhutan.svg": [
		57447,
		7447
	],
	"./countries/bolivia.svg": [
		81469,
		1469
	],
	"./countries/bonaire.svg": [
		67509,
		7509
	],
	"./countries/bosnia-and-herzegovina.svg": [
		42240,
		2240
	],
	"./countries/botswana.svg": [
		59346,
		9346
	],
	"./countries/brazil.svg": [
		6881,
		6881
	],
	"./countries/british-columbia.svg": [
		50333,
		333
	],
	"./countries/british-indian-ocean-territory.svg": [
		43128,
		3128
	],
	"./countries/british-virgin-islands.svg": [
		41475,
		1475
	],
	"./countries/brunei.svg": [
		49896,
		9896
	],
	"./countries/bulgaria.svg": [
		18632,
		8632
	],
	"./countries/burkina-faso.svg": [
		40315,
		315
	],
	"./countries/burundi.svg": [
		94438,
		4438
	],
	"./countries/cambodia.svg": [
		20389,
		389
	],
	"./countries/cameroon.svg": [
		84539,
		4539
	],
	"./countries/canada.svg": [
		48765,
		8765
	],
	"./countries/canary-islands.svg": [
		24750,
		4750
	],
	"./countries/cape-verde.svg": [
		51699,
		1699
	],
	"./countries/cayman-islands.svg": [
		2149,
		2149
	],
	"./countries/central-african-republic.svg": [
		40482,
		482
	],
	"./countries/ceuta.svg": [
		98729,
		8729
	],
	"./countries/chad.svg": [
		25765,
		5765
	],
	"./countries/chile.svg": [
		10898,
		898
	],
	"./countries/china.svg": [
		93044,
		3044
	],
	"./countries/christmas-island.svg": [
		12985,
		2985
	],
	"./countries/cocos-island.svg": [
		3612,
		3612
	],
	"./countries/colombia.svg": [
		22609,
		2609
	],
	"./countries/comoros.svg": [
		94187,
		4187
	],
	"./countries/cook-islands.svg": [
		88662,
		8662
	],
	"./countries/corsica.svg": [
		61241,
		1241
	],
	"./countries/costa-rica.svg": [
		59061,
		9061
	],
	"./countries/croatia.svg": [
		91206,
		1206
	],
	"./countries/cuba.svg": [
		86600,
		6600
	],
	"./countries/curacao.svg": [
		87927,
		7927
	],
	"./countries/cyprus.svg": [
		15773,
		5773
	],
	"./countries/czech-republic.svg": [
		58693,
		8693
	],
	"./countries/democratic-republic-of-congo.svg": [
		16846,
		6846
	],
	"./countries/denmark.svg": [
		85555,
		5555
	],
	"./countries/djibouti.svg": [
		10509,
		509
	],
	"./countries/dominica.svg": [
		38661,
		8661
	],
	"./countries/dominican-republic.svg": [
		17734,
		7734
	],
	"./countries/east-timor.svg": [
		19802,
		9802
	],
	"./countries/ecuador.svg": [
		22292,
		2292
	],
	"./countries/egypt.svg": [
		54460,
		4460
	],
	"./countries/england.svg": [
		23778,
		3778
	],
	"./countries/equatorial-guinea.svg": [
		60974,
		974
	],
	"./countries/eritrea.svg": [
		42847,
		2847
	],
	"./countries/estonia.svg": [
		50620,
		620
	],
	"./countries/ethiopia.svg": [
		43462,
		3462
	],
	"./countries/european-union.svg": [
		68810,
		8810
	],
	"./countries/falkland-islands.svg": [
		17413,
		7413
	],
	"./countries/faroe-islands.svg": [
		49651,
		9651
	],
	"./countries/fiji.svg": [
		4475,
		4475
	],
	"./countries/finland.svg": [
		28533,
		8533
	],
	"./countries/france.svg": [
		82466,
		2466
	],
	"./countries/french-polynesia.svg": [
		53450,
		3450
	],
	"./countries/french-southern-territories.svg": [
		1869,
		1869
	],
	"./countries/gabon.svg": [
		50500,
		500
	],
	"./countries/galapagos-islands.svg": [
		47381,
		7381
	],
	"./countries/gambia.svg": [
		99552,
		9552
	],
	"./countries/georgia.svg": [
		97049,
		7049
	],
	"./countries/germany.svg": [
		97878,
		7878
	],
	"./countries/ghana.svg": [
		97120,
		7120
	],
	"./countries/gibraltar.svg": [
		9305,
		9305
	],
	"./countries/greece.svg": [
		75530,
		5530
	],
	"./countries/greenland.svg": [
		71671,
		1671
	],
	"./countries/grenada.svg": [
		78263,
		8263
	],
	"./countries/guam.svg": [
		61145,
		1145
	],
	"./countries/guatemala.svg": [
		39818,
		9818
	],
	"./countries/guernsey.svg": [
		77749,
		7749
	],
	"./countries/guinea-bissau.svg": [
		9686,
		9686
	],
	"./countries/guinea.svg": [
		21272,
		1272
	],
	"./countries/guyana.svg": [
		58826,
		8826
	],
	"./countries/haiti.svg": [
		30562,
		562
	],
	"./countries/hawaii.svg": [
		22556,
		2556
	],
	"./countries/honduras.svg": [
		9067,
		9067
	],
	"./countries/hong-kong.svg": [
		82161,
		2161
	],
	"./countries/hungary.svg": [
		37583,
		7583
	],
	"./countries/iceland.svg": [
		1803,
		1803
	],
	"./countries/india.svg": [
		15224,
		5224
	],
	"./countries/indonesia.svg": [
		87847,
		7847
	],
	"./countries/iran.svg": [
		32747,
		2747
	],
	"./countries/iraq.svg": [
		41871,
		4252
	],
	"./countries/ireland.svg": [
		49752,
		9752
	],
	"./countries/isle-of-man.svg": [
		59687,
		9687
	],
	"./countries/israel.svg": [
		6515,
		6515
	],
	"./countries/italy.svg": [
		4328,
		4328
	],
	"./countries/ivory-coast.svg": [
		81719,
		1719
	],
	"./countries/jamaica.svg": [
		89303,
		9303
	],
	"./countries/japan.svg": [
		97181,
		7181
	],
	"./countries/jersey.svg": [
		36331,
		6331
	],
	"./countries/jordan.svg": [
		71897,
		1897
	],
	"./countries/kazakhstan.svg": [
		25509,
		5509
	],
	"./countries/kenya.svg": [
		72573,
		2573
	],
	"./countries/kiribati.svg": [
		39966,
		9966
	],
	"./countries/kosovo.svg": [
		14270,
		4270
	],
	"./countries/kuwait.svg": [
		60980,
		980
	],
	"./countries/kyrgyzstan.svg": [
		951,
		951
	],
	"./countries/laos.svg": [
		57316,
		7316
	],
	"./countries/latvia.svg": [
		10078,
		78
	],
	"./countries/lebanon.svg": [
		58154,
		8154
	],
	"./countries/lesotho.svg": [
		34299,
		4299
	],
	"./countries/liberia.svg": [
		83595,
		3595
	],
	"./countries/libya.svg": [
		64634,
		4634
	],
	"./countries/liechtenstein.svg": [
		94018,
		4018
	],
	"./countries/lithuania.svg": [
		28008,
		8008
	],
	"./countries/luxembourg.svg": [
		28127,
		8127
	],
	"./countries/macao.svg": [
		94440,
		4440
	],
	"./countries/macedonia.svg": [
		17746,
		7746
	],
	"./countries/madagascar.svg": [
		87291,
		7291
	],
	"./countries/madeira.svg": [
		69382,
		9382
	],
	"./countries/malawi.svg": [
		49668,
		9668
	],
	"./countries/malaysia.svg": [
		48242,
		8242
	],
	"./countries/maldives.svg": [
		16296,
		6296
	],
	"./countries/mali.svg": [
		99528,
		9528
	],
	"./countries/malta.svg": [
		79542,
		9542
	],
	"./countries/marshall-island.svg": [
		92241,
		2241
	],
	"./countries/martinique.svg": [
		55930,
		5930
	],
	"./countries/mauritania.svg": [
		60056,
		56
	],
	"./countries/mauritius.svg": [
		29980,
		9980
	],
	"./countries/melilla.svg": [
		74245,
		4245
	],
	"./countries/mexico.svg": [
		23438,
		3438
	],
	"./countries/micronesia.svg": [
		64255,
		4255
	],
	"./countries/moldova.svg": [
		73981,
		3981
	],
	"./countries/monaco.svg": [
		74066,
		4066
	],
	"./countries/mongolia.svg": [
		42669,
		2669
	],
	"./countries/montenegro.svg": [
		54589,
		4589
	],
	"./countries/montserrat.svg": [
		94358,
		4358
	],
	"./countries/morocco.svg": [
		26511,
		6511
	],
	"./countries/mozambique.svg": [
		96041,
		6041
	],
	"./countries/myanmar.svg": [
		16572,
		6572
	],
	"./countries/namibia.svg": [
		28622,
		8622
	],
	"./countries/nato.svg": [
		90223,
		223
	],
	"./countries/nauru.svg": [
		49350,
		9350
	],
	"./countries/nepal.svg": [
		99207,
		9207
	],
	"./countries/netherlands-antilles.svg": [
		81054,
		1054
	],
	"./countries/netherlands.svg": [
		56109,
		6109
	],
	"./countries/new-zealand.svg": [
		75751,
		5751
	],
	"./countries/nicaragua.svg": [
		36028,
		6028
	],
	"./countries/niger.svg": [
		64158,
		4158
	],
	"./countries/nigeria.svg": [
		71600,
		1600
	],
	"./countries/niue.svg": [
		73214,
		3214
	],
	"./countries/norfolk-island.svg": [
		32028,
		2028
	],
	"./countries/north-korea.svg": [
		84405,
		4405
	],
	"./countries/northen-cyprus.svg": [
		57484,
		7484
	],
	"./countries/northern-marianas-islands.svg": [
		46923,
		6923
	],
	"./countries/norway.svg": [
		50785,
		785
	],
	"./countries/oman.svg": [
		26602,
		6602
	],
	"./countries/orkney-islands.svg": [
		50020,
		20
	],
	"./countries/ossetia.svg": [
		68313,
		8313
	],
	"./countries/pakistan.svg": [
		46498,
		6498
	],
	"./countries/palau.svg": [
		13760,
		3760
	],
	"./countries/palestine.svg": [
		95132,
		5132
	],
	"./countries/panama.svg": [
		39883,
		9883
	],
	"./countries/papua-new-guinea.svg": [
		2181,
		2181
	],
	"./countries/paraguay.svg": [
		45099,
		5099
	],
	"./countries/peru.svg": [
		61013,
		1013
	],
	"./countries/philippines.svg": [
		51712,
		1712
	],
	"./countries/pitcairn-islands.svg": [
		38230,
		8230
	],
	"./countries/portugal.svg": [
		28913,
		8913
	],
	"./countries/puerto-rico.svg": [
		14296,
		4296
	],
	"./countries/qatar.svg": [
		83150,
		3150
	],
	"./countries/rapa-nui.svg": [
		73570,
		3570
	],
	"./countries/republic-of-macedonia.svg": [
		48515,
		8515
	],
	"./countries/republic-of-poland.svg": [
		34776,
		4776
	],
	"./countries/republic-of-the-congo.svg": [
		57040,
		7040
	],
	"./countries/romania.svg": [
		83108,
		3108
	],
	"./countries/russia.svg": [
		42328,
		2328
	],
	"./countries/rwanda.svg": [
		6578,
		6578
	],
	"./countries/saba-island.svg": [
		88750,
		8750
	],
	"./countries/saint-kitts-and-nevis.svg": [
		30082,
		82
	],
	"./countries/salvador.svg": [
		75381,
		5381
	],
	"./countries/samoa.svg": [
		12967,
		5348
	],
	"./countries/san-marino.svg": [
		24660,
		4660
	],
	"./countries/sao-tome-and-principe.svg": [
		18817,
		8817
	],
	"./countries/sardinia.svg": [
		54754,
		4754
	],
	"./countries/saudi-arabia.svg": [
		95824,
		5824
	],
	"./countries/scotland.svg": [
		40811,
		811
	],
	"./countries/senegal.svg": [
		10280,
		280
	],
	"./countries/serbia.svg": [
		45353,
		5353
	],
	"./countries/seychelles.svg": [
		23142,
		3142
	],
	"./countries/sierra-leone.svg": [
		85921,
		5921
	],
	"./countries/singapore.svg": [
		57591,
		7591
	],
	"./countries/sint-eustatius.svg": [
		91723,
		1723
	],
	"./countries/sint-maarten.svg": [
		3222,
		3222
	],
	"./countries/slovakia.svg": [
		65535,
		5535
	],
	"./countries/slovenia.svg": [
		19634,
		9634
	],
	"./countries/solomon-islands.svg": [
		3945,
		3945
	],
	"./countries/somalia.svg": [
		41483,
		1483
	],
	"./countries/somaliland.svg": [
		51537,
		1537
	],
	"./countries/south-africa.svg": [
		9841,
		9841
	],
	"./countries/south-korea.svg": [
		98651,
		8651
	],
	"./countries/south-sudan.svg": [
		89308,
		9308
	],
	"./countries/spain.svg": [
		31438,
		1438
	],
	"./countries/sri-lanka.svg": [
		54807,
		4807
	],
	"./countries/st-barts.svg": [
		35277,
		5277
	],
	"./countries/st-lucia.svg": [
		41643,
		1643
	],
	"./countries/st-vincent-and-the-grenadines.svg": [
		80807,
		807
	],
	"./countries/sudan.svg": [
		29996,
		9996
	],
	"./countries/suriname.svg": [
		16945,
		6945
	],
	"./countries/swaziland.svg": [
		57838,
		7838
	],
	"./countries/sweden.svg": [
		84323,
		4323
	],
	"./countries/switzerland.svg": [
		51562,
		1562
	],
	"./countries/syria.svg": [
		42621,
		2621
	],
	"./countries/taiwan.svg": [
		81311,
		1311
	],
	"./countries/tajikistan.svg": [
		14169,
		4169
	],
	"./countries/tanzania.svg": [
		24085,
		4085
	],
	"./countries/thailand.svg": [
		17222,
		7222
	],
	"./countries/tibet.svg": [
		659,
		659
	],
	"./countries/togo.svg": [
		754,
		754
	],
	"./countries/tokelau.svg": [
		28822,
		8822
	],
	"./countries/tonga.svg": [
		84582,
		4582
	],
	"./countries/transnistria.svg": [
		75427,
		5427
	],
	"./countries/trinidad-and-tobago.svg": [
		37263,
		7263
	],
	"./countries/tunisia.svg": [
		12106,
		2106
	],
	"./countries/turkey.svg": [
		5385,
		5385
	],
	"./countries/turkmenistan.svg": [
		90806,
		806
	],
	"./countries/turks-and-caicos.svg": [
		7933,
		7933
	],
	"./countries/tuvalu.svg": [
		600,
		600
	],
	"./countries/uganda.svg": [
		67443,
		7443
	],
	"./countries/ukraine.svg": [
		30214,
		214
	],
	"./countries/united-arab-emirates.svg": [
		63800,
		3800
	],
	"./countries/united-kingdom.svg": [
		8422,
		8422
	],
	"./countries/united-nations.svg": [
		50849,
		849
	],
	"./countries/united-states-of-america.svg": [
		38034,
		8034
	],
	"./countries/uruguay.svg": [
		37038,
		4657
	],
	"./countries/uzbekistn.svg": [
		78910,
		8910
	],
	"./countries/vanuatu.svg": [
		27689,
		7689
	],
	"./countries/vatican-city.svg": [
		26363,
		6363
	],
	"./countries/venezuela.svg": [
		53168,
		3168
	],
	"./countries/vietnam.svg": [
		96221,
		983
	],
	"./countries/virgin-islands.svg": [
		67577,
		7577
	],
	"./countries/wales.svg": [
		92989,
		2989
	],
	"./countries/western-sahara.svg": [
		81006,
		1006
	],
	"./countries/yemen.svg": [
		6047,
		6047
	],
	"./countries/zambia.svg": [
		30123,
		123
	],
	"./countries/zimbabwe.svg": [
		43544,
		3544
	],
	"./icons/check-icon-filled.svg": [
		63934,
		3934
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 11839;
module.exports = webpackAsyncContext;